<template>
  <div>
    <b-button @click="goBack" size="small" variant="secondary">Back to Schedule</b-button>
    <h1>Shift Details</h1>
    <div v-if="isLoaded">
      <div class="row">
        <div class="col">
          <h2>{{ shift.venue.name }}</h2>
          <h3>{{ shift.venue.location }}</h3>
          <h5 style="font-family:unset;">{{ shift.primary_type }}</h5>
          <h5 v-if="shift.secondary_type!='-'&&shift.seconday_type!=null" style="font-family:unset;">{{ shift.secondary_type }}</h5>
          <h5 style="font-family:unset;"> {{ shift.studentVolunteers.length }}  /  {{ shift.sv_slots }} possible SVs assigned</h5>
          <h3 v-if="shift.special">{{ shift.special }}</h3>

        </div>
        <div class="col">
          <h2>{{ formattedDay(shift.day) }}</h2>
          <h2>{{ shift.start_time }} - {{ shift.end_time }}</h2>
        </div>
      </div>
      <hr/>
      <h2>Volunteers</h2>
      <b-table striped :fields="fields" :items="svs">
        <template slot="name" slot-scope="data">
          {{ data.item.name }}
          <em v-if="data.item.start_back_to_back"><br/>Arriving from a back to back shift with {{ data.item.start_back_to_back }}</em>
          <em v-if="data.item.end_back_to_back"><br/>Departing to a back to back shift with {{ data.item.end_back_to_back }}</em>
        </template>
        <template slot="check_in" slot-scope="data">
          <b-form-checkbox v-model="data.item.check_in" value="true" unchecked-value="false">
            Check In
          </b-form-checkbox>
        </template>
        <template slot="check_out" slot-scope="data">
          <b-form-checkbox v-model="data.item.check_out" value="true" unchecked-value="false">
            Check Out
          </b-form-checkbox>
        </template>
        <template slot="rating" slot-scope="data">
          <b-form-select v-model="data.item.rating" :options="ratings" class="mb-3" size="sm" />
        </template>
        <template slot="notes" slot-scope="row">
          <b-button size="sm" @click.stop="row.toggleDetails" class="mr-2">
            Write Note
          </b-button>
        </template>
        <template slot="row-details" slot-scope="row">
          <b-form-textarea v-model="row.item.notes" placeholder="Notes about this SV" :rows="3" :max-rows="6">
          </b-form-textarea>
        </template>
      </b-table>
      <div class="row">
        <div class="col-md-10">
          <p><em>Last Updated: {{ lastRefreshDate }}</em> <b-button @click="refreshPage" variant="link"><em>Refresh</em></b-button></p>
        </div>
        <div class="col-md-2">
          <b-button v-if="!isSaving" @click="savePerformanceRecords" variant="secondary">Save and Return</b-button>
          <b-button v-else disabled variant="secondary">Saving...</b-button>
        </div>
      </div>
    </div>
    <div v-else>
      <h1>Loading Shift...</h1>
    </div>
  </div>
  <!-- Show Shift Info -->
  <!-- List SVs with check in/out, rating, and notes -->
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import Alert from '@/components/Alert'
  import Nav from '@/components/Nav'
  import router from '@/router'
  import moment from 'moment'

  export default {
    name: 'Shift',
    props: ['id'],
    data () {
      return {
        ratings: [
          { value: 0, text: 'Select' },
          { value: 1, text: '1' },
          { value: 2, text: '2' },
          { value: 3, text: '3' },
          { value: 4, text: '4' },
          { value: 5, text: '5' }
        ],
        fields: [
          { key: 'name', sortable: true, label: 'Name' },
          { key: 'check_in', label: 'Check In' },
          { key: 'check_out', label: 'Check Out' },
          { key: 'rating', label: 'Rating' },
          { key: 'notes', label: 'Notes' }
        ],
        svs: [],
        isSaving: false
      }
    },
    methods: {
      goBack: function () {
        router.push('/schedule/tl')
      },
      formattedDay: function (day) {
        return moment(day).utc().format('ddd MMM Do')
      },
      getSvs: function () {
        return this.shift.studentVolunteers.map(sv => {
          let name = sv.given_name + ' ' + sv.family_name
          if (sv.nickname && sv.nickname !== '' && sv.given_name !== sv.nickname) {
            name = sv.given_name + ' "' + sv.nickname + '" ' + sv.family_name
          }
          let record = {
            id: sv.performance_record.id,
            shift_id: this.id,
            student_volunteer_id: sv.id,
            name: name,
            check_in: sv.performance_record.check_in,
            check_out: sv.performance_record.check_out,
            rating: sv.performance_record.rating === null ? 0 : sv.performance_record.rating,
            notes: sv.performance_record.notes,
            start_back_to_back: sv.start_back_to_back,
            end_back_to_back: sv.end_back_to_back
          }
          if (sv.performance_record.notes !== '' && sv.performance_record.notes !== null) {
            record._showDetails = true
          }
          return record
        })
      },
      savePerformanceRecords: function () {
        this.isSaving = true
        this.$store.dispatch('schedule/savePerformanceRecords', this.svs).then(() => {
          router.push('/schedule/tl')
        }).catch(err => {
          console.log(err)
          this.isSaving = false
        })
      },
      refreshPage: function () {
        location.reload()
      }
    },
    computed: {
      ...mapGetters(['isError', 'isMessage']),
      ...mapState('schedule', ['shifts', 'isLoaded', 'lastRefreshDate']),
      ...mapState('user', ['isTeamLeader']),
      shift: function () {
        let shift = this.shifts.find(s => {
          return s.id === parseInt(this.id)
        })
        return shift
      }
    },
    components: {
      alert: Alert,
      navigation: Nav
    },
    created () {
      if (!this.$store.state.schedule.isLoaded) {
        this.$store.dispatch('schedule/load').then(() => {
          this.svs = this.getSvs()
        })
      } else {
        this.svs = this.getSvs()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/schedule/Shift.vue